var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "error" }, [_vm._v("\n  视阅\n")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }